module.exports = __webpack_public_path__ + "9c465c0693b0b570900b79678daf871a.png";